import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS, LOGOS } from "@/lib/seed-content";

export default function Footer() {
  return (
    <footer className="navy-panel grain text-slate-200" data-testid="site-footer">
      <div className="container-seed py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="inline-flex items-center gap-3 bg-white rounded-xl px-4 py-3">
              <img src={LOGOS.linear} alt="SEED" className="h-8 w-auto" />
            </div>
            <p className="mt-4 text-[11px] tracking-[0.2em] uppercase text-emerald-400/90">
              {BRAND.full}
            </p>
            <p className="mt-5 text-sm text-slate-400 max-w-md leading-relaxed">
              We finance, install and maintain commercial solar for sports clubs, schools and farms
              at <span className="text-white font-semibold">£0 upfront</span> with a{" "}
              <span className="text-white font-semibold">fixed kWh rate for 25 years</span>.
            </p>
            <div className="mt-6 flex flex-col gap-2 text-sm">
              <a href={`mailto:${BRAND.contactEmail}`} className="inline-flex items-center gap-2 text-slate-300 hover:text-emerald-400">
                <Mail className="w-4 h-4" /> {BRAND.contactEmail}
              </a>
              <a href={`tel:${BRAND.contactPhone.replace(/\s/g, "")}`} className="inline-flex items-center gap-2 text-slate-300 hover:text-emerald-400">
                <Phone className="w-4 h-4" /> {BRAND.contactPhone}
              </a>
              <div className="inline-flex items-start gap-2 text-slate-400">
                <MapPin className="w-4 h-4 mt-0.5 flex-none" />
                <span className="leading-relaxed">{BRAND.contactAddress}</span>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-overline">Sectors</div>
            <ul className="mt-4 space-y-2 text-sm">
              {NAV_LINKS.slice(0, 3).map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.to.replace(/\//g, "-")}`}
                    className="text-slate-300 hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-overline">Resources</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/trustee-hub" className="text-slate-300 hover:text-white">Trustee Hub</Link></li>
              <li><Link to="/case-study" className="text-slate-300 hover:text-white">Case Study</Link></li>
              <li><Link to="/contact" className="text-slate-300 hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-overline">Get started</div>
            <Link
              to="/contact"
              data-testid="footer-book-assessment-btn"
              className="mt-4 inline-flex items-center justify-center w-full bg-emerald-500 hover:bg-emerald-600 text-white font-semibold py-3 px-4 rounded-lg text-sm"
            >
              Book Assessment
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between text-xs text-slate-500">
          <div>© {new Date().getFullYear()} {BRAND.full}. All rights reserved.</div>
          <div className="flex gap-4">
            <span>Registered in England &amp; Wales</span>
            <span>·</span>
            <span>Maintenance &amp; performance included</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
